export const WISHLIST_LS_KEY = 'urbanai:wishlist'

export function loadWishlist() {
  try {
    const raw = localStorage.getItem(WISHLIST_LS_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    if (Array.isArray(parsed)) return parsed
    return []
  } catch (_) {
    return []
  }
}

export function saveWishlist(items) {
  try {
    const safe = Array.isArray(items) ? items : []
    localStorage.setItem(WISHLIST_LS_KEY, JSON.stringify(safe))
  } catch (_) {
    // ignore
  }
}